import { PotRow } from './PotRow';

/**
 * Lista de cofres com cartões separados e espaçamento entre entradas.
 */
export function PotSection({ title, pots, countLabel }) {
  if (!pots.length) return null;

  const showHeader = Boolean(title || countLabel);

  return (
    <section className="flex w-full min-w-0 flex-col gap-3">
      {showHeader ? (
        <div className="flex min-w-0 items-center justify-between gap-2 px-0.5">
          {title ? (
            <h2 className="text-xs font-semibold uppercase tracking-wide text-muted-foreground md:text-sm">
              {title}
            </h2>
          ) : (
            <span />
          )}
          {countLabel ? (
            <span className="shrink-0 text-[10px] text-muted-foreground md:text-xs">{countLabel}</span>
          ) : null}
        </div>
      ) : null}
      <ul className="flex w-full min-w-0 flex-col gap-3">
        {pots.map((pot) => (
          <PotRow key={pot.id} pot={pot} variant="card" />
        ))}
      </ul>
    </section>
  );
}
